import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Treatments } from './components/Treatments';
import { WhyMantra } from './components/WhyMantra';
import { Gallery } from './components/Gallery';
import { Testimonials } from './components/Testimonials';
import { Team } from './components/Team';
import { Locations } from './components/Locations';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-ivory font-sans text-charcoal selection:bg-rosegold/30" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <SocialProof data-id="element-4" />
        <Treatments data-id="element-5" />
        <WhyMantra data-id="element-6" />
        <Gallery data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Team data-id="element-9" />
        <Locations data-id="element-10" />
        <FinalCTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}